const EN = {
  'eclipse.interior.image-1.hotspot-1.label': 'Steering & Dashboard',
  'eclipse.interior.image-1.hotspot-1.message': 'Steering and dashboard',
  'eclipse.interior.image-1.hotspot-2.label': 'Climate Control',
  'eclipse.interior.image-1.hotspot-2.message': 'Climate control',
  'eclipse.interior.image-1.hotspot-3.label': 'Gearshift &\nCenter Console',
  'eclipse.interior.image-1.hotspot-3.message': 'Gearshift and center console',
  'eclipse.interior.image-1.hotspot-4.label': "Driver's seat",
  'eclipse.interior.image-1.hotspot-4.message': "Driver's seat",
  'eclipse.interior.image-1.hotspot-5.label': 'Connectivity & Infotainment',
  'eclipse.interior.image-1.hotspot-5.message': 'Connectivity and infotainment',

  'eclipse.interior.image-2.hotspot-1.label': '2nd-Row Amenities',
  'eclipse.interior.image-2.hotspot-1.message': '2nd-row amenities',
  'eclipse.interior.image-2.hotspot-2.label': 'Leather Appointed Seats',
  'eclipse.interior.image-2.hotspot-2.message': 'Leather appointed seats',
  'eclipse.interior.image-2.hotspot-3.label': 'Active Safety Features',
  'eclipse.interior.image-2.hotspot-3.message': 'Active safety features',
  'eclipse.interior.image-2.hotspot-4.label': 'Seatbelts & Restraint Systems',
  'eclipse.interior.image-2.hotspot-4.message': 'Seatbelts and restraint systems',

  'eclipse.exterior.hotspot-1.label': 'Engine & Transmission',
  'eclipse.exterior.hotspot-1.message': 'Engine and transmission',
  'eclipse.exterior.hotspot-2.label': 'Super All-Wheel Control',
  'eclipse.exterior.hotspot-2.message': 'Super All-Wheel Control',
  'eclipse.exterior.hotspot-3.label': 'Wheels & Tires',
  'eclipse.exterior.hotspot-3.message': 'Wheels and tires',
  'eclipse.exterior.hotspot-4.label': 'Liftgate & Fuel Filler',
  'eclipse.exterior.hotspot-4.message': 'Liftgate and fuel filler',
  'eclipse.exterior.hotspot-5.label': 'Active Safety Features',
  'eclipse.exterior.hotspot-5.message': 'Active safety features',

  'eclipse.blueprint.safety.tab-1': 'Side-impact curtain airbags',
  'eclipse.blueprint.safety.tab-2': 'Driver knee airbag',
  'eclipse.blueprint.safety.tab-3': 'Dual front airbags',
  'eclipse.blueprint.safety.tab-4': 'Front seat-mounted side-impact airbags',
  'eclipse.blueprint.safety.hotspot-1.label': 'Side-impact curtain\nairbags (1st & 2nd row)',
  'eclipse.blueprint.safety.hotspot-1.message': 'Side-impact curtain airbags (1st & 2nd row)',
  'eclipse.blueprint.safety.hotspot-2.label': 'Driver knee airbag',
  'eclipse.blueprint.safety.hotspot-2.message': 'Driver knee airbag',
  'eclipse.blueprint.safety.hotspot-3.label': 'Dual front airbags',
  'eclipse.blueprint.safety.hotspot-3.message': 'Dual front airbags',
  'eclipse.blueprint.safety.hotspot-4.label': 'Front seat-mounted\nside-impact airbags',
  'eclipse.blueprint.safety.hotspot-4.message': 'Front seat-mounted side-impact airbags',

  'eclipse-cross.launcher.introduction': 'Click to ask anything about the Eclipse Cross',
}

export default EN
